/**
 * Environment configuration utilities for Sanity Studio v4
 * Migrated from v2 sanity.json __experimental_spaces configuration
 */

export interface EnvironmentConfig {
  projectId: string
  dataset: string
  feURL: string
  isDevelopment: boolean
  isProduction: boolean
}

/**
 * Get the current environment configuration
 * Equivalent to v2's client.clientConfig access
 */
export function getEnvironmentConfig(): EnvironmentConfig {
  const isDevelopment = process.env.NODE_ENV !== 'production'
  const isProduction = process.env.NODE_ENV === 'production'

  return {
    projectId: process.env.SANITY_STUDIO_PROJECT_ID || 'c8ihu5xk',
    dataset: process.env.SANITY_STUDIO_DATASET || (isProduction ? 'production' : 'preview'),
    feURL: process.env.SANITY_STUDIO_FE_URL || (isProduction ? 'https://apexwheels.com' : 'http://localhost:3000'),
    isDevelopment,
    isProduction,
  }
}

/**
 * Get the frontend URL for API calls
 * Replaces v2's client.clientConfig.feURL
 */
export function getFrontendURL(): string {
  // In development, we might want to use a proxy to avoid CORS issues
  // This can be configured based on environment
  const config = getEnvironmentConfig()
  
  // If we're in Sanity Studio and making requests to a different port,
  // we could potentially use a proxy endpoint instead of direct calls
  return config.feURL
}

/**
 * Environment-specific dataset mapping
 * Based on v2 __experimental_spaces configuration
 */
export const ENVIRONMENT_DATASETS = {
  development: 'preview',
  preview: 'preview', 
  production: 'production',
} as const

/**
 * Environment-specific frontend URLs
 * Based on v2 __experimental_spaces configuration
 */
export const ENVIRONMENT_URLS = {
  development: 'http://localhost:3000',
  preview: 'https://preview.apexwheels.com',
  production: 'https://apexwheels.com',
} as const